import React, { useState } from 'react';
import { Link } from "react-router-dom";

import StarRatings from 'react-star-ratings';
import b1 from "../../assets/images/b1.jpg"
import profile1 from "../../assets/images/profile1.jpg"
import classes from "./UserProfile.module.css"



export const UserProfile=()=>{

 let [data,setData]=useState({
    businessName:"Business Name"
 })
 let [editBusinessName,setEditBusinessName]=useState(false)
 let [editDescription,setEditDescription]=useState(false)

 const gethovered=()=>{
     var hoverEffect = document.getElementById('savePassword').style;
     hoverEffect.backgroundColor="white";
     hoverEffect.transition="0.75s";
     hoverEffect.transitionDelay=".25s";
     hoverEffect.transitionDuration=".5s";
     hoverEffect.color="black";
 }
 const gethovered2=()=>{
    var hoverEffect = document.getElementById('savePassword').style;
    hoverEffect.backgroundColor="black";
    hoverEffect.transition="0.75s";
    hoverEffect.transitionDelay=".25s";
    hoverEffect.transitionDuration=".5s";
    hoverEffect.color="white";
}
function handleChange(e) {
    setData({
        [e.target.name]: e.target.value
    });
  }
    return(
        <>
        <div className="descriptionPage">
            {/* banner */}
            <div className={classes.descBanner}>
                <div className={classes.imgDiv}>
                    <img src={b1} alt="banner" />
                </div>
                <div className={classes.descBannerContent}>
                    <div className="container">
                        <div className={classes.bisHeadingDiv}>
                            {editBusinessName == false?
                            <>
                            <h1>{data.businessName}</h1>
                            <span><i class="fa fa-pencil-square-o ml-2 cursorP" onClick={()=>setEditBusinessName(true)} aria-hidden="true"></i></span>
                            </>
                            :
                            <>
                            <input type="text" className="form-control" name="businessName" onChange={(e)=>handleChange(e)} value={data.businessName} style={{width:"250px"}} />
                            <span className="mlNeg25"><i class="fa fa-check cursorP" onClick={()=>setEditBusinessName(false)} aria-hidden="true"></i></span>
                            {/* <span><i class="fa fa-times-circle ml-4" onClick={()=>setEditBusinessName(false)} aria-hidden="true"></i></span> */}
                            </>
                            }

                        </div>

                    <div className={classes.reviewDiv}>
                        <StarRatings
                        rating={4.403}
                        starDimension="18px"
                        starSpacing="1px"
                        numberOfStars={5}
                        starRatedColor="orange"
                        />
                        <span className={classes.reviewSpan}>(1 Review)</span>
                    </div>
                    <div className={classes.descBannerLinkContainer}>
                        <div className={classes.descBannerLink}>
                            <div className="mr-4 mb-2">
                                <i className="fa fa-map-marker mr-2"></i>
                                <span>111 Clay St, Brooklyn</span>
                            </div>
                            <div className="mr-4 mb-2">
                                <i className="fa fa-phone mr-2"></i>
                                <span><a href="tel:92123456">981234567</a></span>
                            </div>
                            <div className="mr-4 mb-2">
                                <i className="fa fa-envelope-open mr-2"></i>
                                <span><a href="mailto:someone@example.com">example@gmail.com</a></span>
                            </div>
                        </div>
                        <div className={classes.writeReviewDiv}>
                            <label className={classes.WriteRevBtn} >Change cover
                            <input type="file" />
                            </label>
                        </div>

                    </div>

                </div>
                </div>
            </div>
            
            {/* description */}
            <section className="container">
                {/* logo */}
                <div className="row mx-0">
                    <div className={classes.logoDiv}><img src={profile1} alt="" /></div>
                    <div className={classes.EditLogoDiv}>
                            <label className={classes.EditLogo} >
                                <span><i class="fa fa-pencil-square-o ml-2" aria-hidden="true"></i></span>
                                <input type="file" />
                            </label>
                    </div>

                </div>

                {/* password change */}
                <div className={classes.ChangePassDiv}>
                    <span>Change Password</span>
                    <input type="text" className={classes.oldpassInput} placeholder="Old Password" name="oldPassword" value="" style={{width:"250px"}} />
                    <input type="text" className= {classes.newpassInput} placeholder="New Password" name="newPassword" value="" style={{width:"250px"}} />
                    <button className="savePassword" >Save</button>
                </div>

                <div className="row">
                    <div className="col-lg-8">
                        <div className={classes.descDiv}>
                            {editDescription == true
                            ?
                            <>
                                <span className={classes.closeDesc}><i class="fa fa-times-circle ml-4" onClick={()=>setEditDescription(false)} aria-hidden="true"></i></span>
                                <textarea className="form-control" placeholder="Description ..." name="description"  rows="4" cols="50">
                                </textarea>
                                <button className={classes.saveDescBtn} onClick={()=>setEditDescription(false)}>Save</button>
                            </>
                            :
                            <>
                            <div className={classes.EditDesDiv}>
                                <label className={classes.EditLogo}>
                                    <span><i class="fa fa-pencil-square-o ml-2" onClick={()=>setEditDescription(true)} aria-hidden="true"></i></span>
                                </label>
                            </div>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Delectus, reprehenderit et voluptates at corrupti eum culpa non est numquam nemo beatae modi id quia illum, magnam similique eaque. Sint, cupiditate?</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum culpa ab voluptatum vero quae dolor, nihil pariatur est! Facilis esse aliquid quo molestias est cumque consequatur mollitia asperiores reprehenderit sequi.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum culpa ab voluptatum vero quae dolor, nihil pariatur est! Facilis esse aliquid quo molestias est cumque consequatur mollitia asperiores reprehenderit sequi.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum culpa ab voluptatum vero quae dolor, nihil pariatur est! Facilis esse aliquid quo molestias est cumque consequatur mollitia asperiores reprehenderit sequi.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum culpa ab voluptatum vero quae dolor, nihil pariatur est! Facilis esse aliquid quo molestias est cumque consequatur mollitia asperiores reprehenderit sequi.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum culpa ab voluptatum vero quae dolor, nihil pariatur est! Facilis esse aliquid quo molestias est cumque consequatur mollitia asperiores reprehenderit sequi.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum culpa ab voluptatum vero quae dolor, nihil pariatur est! Facilis esse aliquid quo molestias est cumque consequatur mollitia asperiores reprehenderit sequi.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum culpa ab voluptatum vero quae dolor, nihil pariatur est! Facilis esse aliquid quo molestias est cumque consequatur mollitia asperiores reprehenderit sequi.</p>
                            </>
                            }
                        </div>
                        <div className={classes.descDiv}>
                            {/* rewiew div */}
                            <div className={classes.reviewContent}>
                                <h3 className="mb-4"><span>1</span> Review</h3>
                                <div className="row">
                                    <div className="col-auto">
                                        <div className={classes.reviewerLogo}>
                                            <img src={profile1} alt="" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex jc-sb">
                                            <h5 className="mb-0">Smith</h5>
                                            <div><span>5</span><span> minutes</span><span> ago</span></div>
                                        </div>
                                        <div className="mb-3">
                                            <StarRatings
                                            rating={4.403}
                                            starDimension="18px"
                                            starSpacing="1px"
                                            numberOfStars={5}
                                            starRatedColor="orange"
                                            />
                                        </div>
                                        <div>
                                            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Facere sit explicabo pariatur iusto enim? Perspiciatis, delectus ducimus tenetur, nemo adipisci totam corporis odit eaque reiciendis sequi quo, dolorum a voluptatibus.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className={classes.descDiv}>
                            {/* time div */}
                            <div>
                                <h4><i class="fa fa-clock-o" aria-hidden="true"></i> Openening Hours</h4>
                                <div className="d-flex jc-sb py-2 colorGray">
                                    <div>Monday</div>
                                    <div className=""><span>8:00am</span>- <span>10:00pm</span></div>
                                </div>
                                <div className="d-flex jc-sb py-2 colorGray">
                                    <div>Tuesday</div>
                                    <div className=""><span>8:00am</span>- <span>10:00pm</span></div>
                                </div>
                                <div className="d-flex jc-sb py-2 colorGray">
                                    <div>Wednesday	</div>
                                    <div className=""><span>8:00am</span>- <span>10:00pm</span></div>
                                </div>
                                <div className="d-flex jc-sb py-2 colorGray">
                                    <div>Thuersday</div>
                                    <div className=""><span>8:00am</span>- <span>10:00pm</span></div>
                                </div>
                                <div className="d-flex jc-sb py-2 colorGray">
                                    <div>Friday</div>
                                    <div className=""><span>8:00am</span>- <span>10:00pm</span></div>
                                </div>
                                <div className="d-flex jc-sb py-2 colorGray">
                                    <div>Saturday</div>
                                    <div className="">closed</div>
                                </div>
                                <div className="d-flex jc-sb py-2 colorGray">
                                    <div>Sunday </div>
                                    <div className="">closed</div>
                                </div>
                            </div>

                        </div>
                       
                        <div className={classes.descDiv}>
                            {/* contact div */}
                            <div>
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.136308596205!2d-73.95546658463427!3d40.737026079329276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2593bf402b47b%3A0x610dbb75dd8f06a4!2s111%20Clay%20St%2C%20Brooklyn%2C%20NY%2011222%2C%20USA!5e0!3m2!1sen!2s!4v1630986222865!5m2!1sen!2s" width="100%" height="300"  allowfullscreen="" loading="lazy"></iframe>
                            </div>
                            <div className={classes.descInnerDiv}>
                                <div className="colorGray border-bottom-light py-3">
                                    <i className="fa fa-map-marker mr-2 iconColor "></i>
                                    <span>111 Clay St, Brooklyn</span>
                                </div>
                                <div className="colorGray border-bottom-light py-3">
                                    <i className="fa fa-phone mr-2 iconColor "></i>
                                    <span><a href="tel:92123456">981234567</a></span>
                                </div>
                                <div className="colorGray border-bottom-light py-3">
                                    <i className="fa fa-envelope-open mr-2 iconColor "></i>
                                    <span><a href="mailto:someone@example.com">example@gmail.com</a></span>
                                </div>
                                <div className={classes.socialIcon}>
                                    <a href="#"><i class="fa fa-facebook fbIconColor mr-4" aria-hidden="true"></i></a>
                                    <a href="#"><i class="fa fa-twitter twitterIconColor mr-4" aria-hidden="true"></i></a>
                                    <a href="#"><i class="fa fa-linkedin  inIconColor mr-4" aria-hidden="true"></i></a>
                                    <a href="#"><i class="fa fa-instagram  instaIconColor mr-4" aria-hidden="true"></i></a>
                                </div>
                            </div>

                        </div>
                   
                    </div>
                </div>
            </section>
        </div>
        </>
    )
}